import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploadScreenDescription: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.upload-screen-description',
		defaultMessage:
			'Start by finding the <b>Download</b> or <b>Export</b> option on your app and export a CSV file. You will need to <link>structure the CSV</link> and upload it to begin the import. Structuring the file will help avoid errors and ensure that the data is in the right format.',
		description: 'Description for upload screen',
	},
	uploadScreenDescriptionNew: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.upload-screen-description-new',
		defaultMessage:
			'Start by finding the <b>Download</b> or <b>Export</b> option on your app and export a CSV file. <link>Structure the CSV</link> to ensure the data is in the right format and upload it to begin.',
		description: 'Description for upload screen',
	},
	uploadScreenCustomisedDescription: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.upload-screen-customised-description',
		defaultMessage:
			"Let's bring your data into Jira. Upload a CSV file from {importType} to begin your import.",
		description: 'Description for upload screen',
	},
	uploadScreenCustomisedDescriptionNew: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.upload-screen-customised-description-new',
		defaultMessage:
			"Let's bring your data into Jira. Export a CSV file from {importType} and upload it to begin.",
		description: 'Description for upload screen',
	},
	setupProjectScreenDescription: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.setup-project-screen-description',
		defaultMessage:
			'Your team’s data will be imported into this project. Check if you’re selecting the right Jira project, template, and project type as these options can’t be modified later.',
		description:
			'Description to inform user they need to name their project and customize the settings',
	},
	setupProjectScreenCustomisedDescription: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.setup-project-screen-customised-description',
		defaultMessage:
			'Your team’s data from {importType} will be imported into this project. Check if you’re selecting the right Jira project, template, and project type as these options can’t be modified later.',
		description:
			'Description to inform user they need to name their project and customize the settings',
	},
	usersMappingScreenColumnHeader: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.users-mapping-screen-column-header',
		defaultMessage: 'Users in CSV',
		description: 'Table header for users in CSV',
	},
	usersMappingScreenCustomisedColumnHeader: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.users-mapping-screen-customised-column-header',
		defaultMessage: 'Users from {importType}',
		description: 'Table header for users in CSV',
	},
	fieldMappingDescription: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-description',
		defaultMessage:
			'We’ve tried to map columns from the CSV file to Jira fields. Organize how your data is presented by verifying and mapping any remaining columns. <link>Read about mapping data</link>',
		description: 'Field mapping description',
	},
	fieldMappingDescriptionWithConfig: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-description-with-config',
		defaultMessage:
			'Some Jira fields may be mapped automatically based on the information in your CSV and configuration files. Organize how your data is presented by verifying and mapping any remaining columns. <link>Read about mapping data</link>',
		description: 'Field mapping description',
	},
	fieldMappingCustomisedDescription: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-customised-description',
		defaultMessage:
			'We’ve automatically mapped a few columns from the CSV file to Jira fields. Organize how your data is presented by verifying and mapping any remaining columns. <link>Read about mapping {importType} data to Jira fields</link>',
		description: 'Field mapping description with product name',
	},
	fieldMappingCustomisedDescriptionWithConfig: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-customised-description-with-config',
		defaultMessage:
			'Some Jira fields may be mapped automatically based on the information in your CSV and configuration files. Organize how your data is presented by verifying and mapping any remaining columns. <link>Read about mapping {importType} data to Jira fields</link>',
		description: 'Field mapping description with product name when there is config',
	},
	fieldMappingTableHeading: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-table-heading',
		defaultMessage: 'Columns in CSV',
		description: 'Field mapping table heading',
	},
	fieldMappingTableCustomisedHeading: {
		id: 'project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-table-customised-heading',
		defaultMessage: 'Columns in {importType} CSV',
		description: 'Field mapping table heading with product name',
	},
});
